export default function(destination, source) {
  destination = destination || {};
  var value, property;
  if (!source) {
    return destination;
  }
  for (property in source) {
    value = source[property];
    if (value !== undefined) {
      destination[property] = value;
    }
  }
  return destination;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/proj4/lib/extend.js
// module id = 260
// module chunks = 0